import { render, staticRenderFns } from "./GridEstados.vue?vue&type=template&id=75471200&"
import script from "./GridEstados.vue?vue&type=script&lang=js&"
export * from "./GridEstados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports